import React from 'react';

interface StampStatusProps {
  status_name: string;
  show: boolean;
}

const StampStatus = ({status_name, show}: StampStatusProps) => {
  if (!show) return null;
  return (
    show &&
        <div className='absolute inset-0 flex items-center justify-center z-10'>
          <div className="-rotate-45 opacity-30">
              <div className="text-[clamp(2.5rem,5vw,4rem)] border-8 border-dashed border-gray-800 text-gray-800 uppercase p-4 leading-none font-extrabold zoomInIcon">
                  { status_name }
              </div>
          </div>
      </div>
  );
};

export default StampStatus;
